import Vue from 'vue'
import Echo from 'laravel-echo'
import VueEcho from 'vue-echo-laravel'
import store from '.././store'

import Pusher from 'pusher-js'

let authorizer = channel => {
  return {
    authorize: (socketId, callback) => {
      let authUrl = ''
      if (channel.name.toLowerCase().indexOf('ticket.') === -1) {
        authUrl = process.env.VUE_APP_TICKET_MODULE + '/broadcasting/auth'
      } else if (channel.name.toLowerCase().indexOf('account.') === -1) {
        authUrl = process.env.VUE_APP_ACCOUNT_MODULE + '/broadcasting/auth'
      } else if (channel.name.toLowerCase().indexOf('service.') === -1) {
        authUrl = process.env.VUE_APP_SERVICE_MODULE + '/broadcasting/auth'
      } else if (channel.name.toLowerCase().indexOf('user.') === -1) {
        authUrl = process.env.VUE_APP_ACCOUNT_MODULE + '/broadcasting/auth'
      } else {
        callback(
          new Error(`Error calling auth endpoint: Channel hasn't been mapped`),
          {
            auth: ''
          }
        )
      }

      fetch(authUrl, {
        method: 'POST',
        headers: new Headers({
          'Content-Type': 'application/json',
          Authorization: 'Bearer ' + store.getters.getAuthToken
        }),
        body: JSON.stringify({
          socket_id: socketId,
          channel_name: channel.name
        })
      })
        .then(res => {
          if (!res.ok) {
            throw new Error(`Received ${res.statusCode} from ${authUrl}`)
          }
          return res.json()
        })
        .then(data => {
          callback(null, data)
        })
        .catch(err => {
          callback(new Error(`Error calling auth endpoint: ${err}`), {
            auth: ''
          })
        })
    }
  }
}

const pusher = new Pusher(process.env.VUE_APP_PUSHER_APP_KEY, {
  cluster: process.env.VUE_APP_PUSHER_APP_CLUSTER,
  authorizer: authorizer,
  forceTLS: true
})

const EchoInstance = new Echo({
  broadcaster: 'pusher',
  key: process.env.VUE_APP_PUSHER_APP_KEY,
  client: pusher
})

Vue.use(VueEcho, EchoInstance)
